export const style = {
  maxHeight: '79vh',
  minHeight: '50vh',
  '&.MuiDataGrid-root': {
    marginTop: 2,
    border: 'unset',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  '.MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '.MuiDataGrid-row': {
    '&.MuiDataGrid-row--editing': {
      '.MuiDataGrid-cell--editable': {
        border: '1.5px solid #C2C2C2',
      },
    },
  },
  '& .MuiButton-root': {
    color: 'success.main',
  },
};
